import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getUTCDate } from '@arc/unified-payments-frontend/date-utils';
import { selectCurrentLanguage, TranslateStoreState } from '../store';

@Pipe({
  name: 'paymentsEngineDatePipe',
})
export class PaymentsEngineDatePipe implements PipeTransform {
  private currentLanguage: string;

  constructor(
    private translateStore: Store<TranslateStoreState>,
    private translationService: TranslateService,
  ) {
    this.translateStore.select(selectCurrentLanguage).subscribe((language) => {
      this.currentLanguage = language;
    });
  }

  transform(
    value: string | number | Date,
    showTime: boolean,
    convertToLocalTime: boolean,
  ): Observable<string> {
    if (!value) {
      return EMPTY;
    }

    this.currentLanguage =
      this.currentLanguage === 'en-us' ? 'en' : this.currentLanguage;

    this.currentLanguage = this.currentLanguage || 'en';

    const datePipe = new DatePipe(this.currentLanguage);
    const localTime = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const customFormat = `${
      this.currentLanguage === 'en' ? 'MMM dd, yyyy' : 'dd MMM yyyy'
    }${showTime ? ' h:mm a' : ''}`;

    const customTimeZone = `${convertToLocalTime ? localTime : 'UTC'}`;
    const monthStr = datePipe.transform(value, 'MMM', customTimeZone);

    const formattedDate = datePipe.transform(
      value,
      customFormat,
      customTimeZone,
    );

    const month = convertToLocalTime
      ? new Date(value).getMonth()
      : getUTCDate(value).getMonth();

    return this.translationService.get('ARC_MONTH_NAMES_SHORT').pipe(
      map((translatedMonths: string[]) => {
        const translatedDate = formattedDate.replace(
          monthStr,
          translatedMonths[month],
        );

        return translatedDate;
      }),
    );
  }
}
